var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPencilLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 14 14",
    fill: "#485056",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00223 14.0001C2.05623 14.0001 2.11023 13.9934 2.16356 13.9801L4.83023 13.3134C4.94756 13.2841 5.05489 13.2234 5.14023 13.1381L13.3356 4.94274C13.5876 4.69074 13.7262 4.35607 13.7262 4.00007C13.7262 3.64407 13.5876 3.3094 13.3356 3.0574L12.2782 2.00007C11.7742 1.49607 10.8969 1.49607 10.3929 2.00007L2.19756 10.1954C2.11223 10.2807 2.05156 10.3881 2.02223 10.5047L1.35556 13.1714C1.29823 13.3987 1.36556 13.6387 1.53089 13.8047C1.65689 13.9314 1.82756 14.0001 2.00223 14.0001ZM11.3356 2.94274L12.3929 4.00007L11.3356 5.0574L10.2782 4.00007L11.3356 2.94274ZM3.27089 11.0074L9.33556 4.94274L10.3929 6.00007L4.32756 12.0647L2.91823 12.4167L3.27089 11.0074Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencilLine);
export default __webpack_public_path__ + "static/media/icon-pencil-line.c8143deabb99710d62fd1466a67fc217.svg";
export { ForwardRef as ReactComponent };